// extracted by mini-css-extract-plugin
module.exports = {"calculatorResult":"result_calculatorResult__i2RpC"};